<template>
    <TransitionRoot :show="open" as="template" @after-leave="query = ''" appear>
        <Dialog as="div" class="relative z-10" @close="closeDialog()">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-800 bg-opacity-50 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 overflow-y-auto p-4 sm:p-6 md:p-20">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 scale-95" enter-to="opacity-100 scale-100" leave="ease-in duration-200" leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
                    <DialogPanel class="mx-auto max-w-xl transform divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all">
                        <form class="space-y-6" @submit.prevent="createChannel">
                            <div class="px-8">
                                <h2 class="font-bold my-8">New Channel Registration</h2>
                                <div class="sm:col-span-4 my-8">
                                    <span class="block text-sm font-medium text-gray-700">Customer</span>
                                    <div class="mt-1 text-gray-400">
                                        {{ customer.name }}
                                    </div>
                                </div>
                                <tailwind-select tabindex="0" :flat="true" label="Channel" value-field="id" @change="form.channel = $event" :options="channelList" :selected-item="form.channel"/>
                                <div class="sm:col-span-4 my-8">
                                    <label for="value" class="block text-sm font-medium text-gray-700">{{ form.channel.name }}</label>
                                    <div class="mt-1">
                                        <input
                                            id="value"
                                            name="value"
                                            tabindex="1"
                                            autocomplete="off"
                                            v-model="form.value"
                                            :type="form.channel.slug === 'email' ? 'email' : 'number'"
                                            :placeholder="'Customer ' + form.channel.name"
                                            class="focus:ring-reethi-purple focus:border-reethi-purple block w-full sm:text-sm border border-gray-300 rounded-md py-2 px-4" />
                                        <div v-if="form.channel.slug === 'email'" class="my-2">
                                            <p
                                                :tabindex="1 + index"
                                                @click="addSuffix(suffix)"
                                                @keyup.space.enter="addSuffix(suffix)"
                                                v-for="(suffix, index) in ['@gmail.com', '@hotmail.com', '@live.com', '@outlook.com', '@icloud.com', '@me.com']"
                                                :class="[this.form.value.length > 2 ? 'border border-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800']"
                                                class="cursor-pointer py-1 px-2 mx-1 mb-2 inline-flex text-xs leading-5 font-semibold rounded-full">
                                                {{ suffix }}
                                            </p>
                                        </div>
                                        <small class="text-red-500" v-if="this.errors['value']">{{ this.errors['value'].join('. ') }}</small>
                                    </div>
                                </div>
                                <div class="flex my-8">
                                    <span class="flex-grow"></span>
                                    <loading-button
                                        tabindex="7"
                                        type="submit"
                                        :loading="processing"
                                        :class="[processing ? 'bg-gray-300' : 'bg-reethi-purple']"
                                        class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        {{ processing ? 'Creating...' : 'Create' }}
                                    </loading-button>
                                </div>
                            </div>
                        </form>
                    </DialogPanel>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
import {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionRoot,
    TransitionChild,
} from "@headlessui/vue";
import axios from 'axios';
import {isProxy, ref, toRaw} from "vue";
import LoadingButton from "@/Shared/LoadingButton";
import TailwindSelect from "@/Shared/Components/TailwindSelect";

export default {
    emits: ['created', 'update:open'],
    props: {
        customer: {
            type: Object,
            required: true,
        },
        open: {
            type: Boolean,
            default: false
        },
        channels: {
            type: Array,
            required: true,
        },
    },
    setup(props) {
        const processing = ref(false);

        return {
            processing,
            channelList: isProxy(props.channels) ? toRaw(props.channels) : props.channels,
            filteredResults: isProxy(props.channels) ? toRaw(props.channels) : props.channels,
        }
    },
    data() {
        return {
            form: {
                value: '',
                channel: this.channelList[1],
            },
            errors: {}
        }
    },
    components: {
        Dialog,
        DialogPanel,
        DialogTitle,
        LoadingButton,
        TailwindSelect,
        TransitionRoot,
        TransitionChild,
    },
    methods: {
        addSuffix(suffix) {
            if (this.form.value && this.form.value.length > 2 && !this.form.value.includes(suffix)) {
                this.form.value = this.form.value + suffix
            }
        },
        async createChannel() {
            this.processing = true
            try {
                const response = await axios.post(this.$route('customers.channels.store', this.customer.id), {
                    value: this.form.value,
                    customer_id: this.customer.id,
                    channel_id: this.form.channel ? this.form.channel.id : null
                });
                this.$emit('created', response);
                this.closeDialog();
            } catch (error) {
                if (error.response && error.response.data) {
                    this.errors = error.response.data.errors;
                }
            }
            this.processing = false
        },
        closeDialog() {
            this.form = {
                value: '',
                channel: this.channelList[1],
            }
            this.$emit('update:open', false)
        }
    }
}
</script>
